var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasicPhotoshoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640.4 500",
    style: {
      enableBackground: "new 0 0 640.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED5338;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.2,78h-9.3V47.5c0-8.1-6.5-14.6-14.6-14.6h-72.4c-8.1,0-14.6,6.5-14.6,14.6V78h-25.8 c-0.2-0.2-0.2-0.5-0.4-0.7L403.3,5.6C400.6,2.1,396.4,0,392,0H248.4c-4.4,0-8.6,2.1-11.3,5.6l-54.8,71.7c-0.2,0.2-0.2,0.5-0.4,0.7 H45.2C20.2,78,0,98.2,0,123.2v331.6c0,25,20.2,45.2,45.2,45.2h549.9c25,0,45.2-20.2,45.2-45.2V123.2C640.3,98.2,620.1,78,595.2,78 L595.2,78z M506.8,55.5h56.4v21.6h-56.4L506.8,55.5L506.8,55.5z M252.5,22.6h135.3l42,55H210.4L252.5,22.6z M617.8,454.8 c0,12.5-10.1,22.6-22.6,22.6h-550c-12.5,0-22.6-10.1-22.6-22.6V123.2c0-12.5,10.1-22.6,22.6-22.6h549.9c12.5,0,22.6,10.1,22.6,22.6 L617.8,454.8L617.8,454.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.2,153.7c-74.7,0-135.2,60.5-135.2,135.2s60.5,135.2,135.2,135.2s135.2-60.5,135.2-135.2 C455.4,214.3,394.9,153.7,320.2,153.7L320.2,153.7z M320.2,401.6c-62.1,0-112.6-50.5-112.6-112.6s50.5-112.6,112.6-112.6 S432.8,226.9,432.8,289S382.3,401.6,320.2,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.7,179.4c0,14.2-11.5,25.7-25.7,25.7s-25.7-11.5-25.7-25.7s11.5-25.7,25.7-25.7S560.7,165.2,560.7,179.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.2,221.4c-37.3,0-67.6,30.3-67.6,67.6s30.3,67.6,67.6,67.6s67.6-30.3,67.6-67.6 C387.8,251.6,357.5,221.4,320.2,221.4z M320.2,334c-24.8,0-45-20.2-45-45s20.2-45,45-45s45,20.2,45,45S345,334,320.2,334z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPhotoshoot);
export default __webpack_public_path__ + "static/media/basic_photoshoot.1a665343ccf67651e9498d03da2406c7.svg";
export { ForwardRef as ReactComponent };